import { render, staticRenderFns } from "./getstartconfirm.vue?vue&type=template&id=57976c40&scoped=true&"
import script from "./getstartconfirm.vue?vue&type=script&lang=js&"
export * from "./getstartconfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57976c40",
  null
  
)

export default component.exports